/* global axios */
import ApiClient from './ApiClient';

class CeaDynamicCatalogsAPI extends ApiClient {
  constructor() {
    super('cea_dynamic_catalogs', { accountScoped: true });
  }

  getCatalogs(params = {}) {
    return axios.get(this.url, { params });
  }

  getCatalog(id) {
    return axios.get(`${this.url}/${id}`);
  }

  createCatalog(data) {
    return axios.post(this.url, { cea_dynamic_catalog: data });
  }

  updateCatalog(id, data) {
    return axios.patch(`${this.url}/${id}`, { cea_dynamic_catalog: data });
  }

  deleteCatalog(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getEntries(catalogId, params = {}) {
    return axios.get(`${this.url}/${catalogId}/entries`, { params });
  }

  createEntry(catalogId, data) {
    return axios.post(`${this.url}/${catalogId}/entries`, {
      cea_dynamic_catalog_entry: data,
    });
  }

  updateEntry(catalogId, entryId, data) {
    return axios.patch(`${this.url}/${catalogId}/entries/${entryId}`, {
      cea_dynamic_catalog_entry: data,
    });
  }

  deleteEntry(catalogId, entryId) {
    return axios.delete(`${this.url}/${catalogId}/entries/${entryId}`);
  }
}

export default new CeaDynamicCatalogsAPI();
